export default __webpack_public_path__ + "static/media/episode3VidM.df6b1820.jpg";